import type { TripItem } from '@/types/portal'
import { isMultiTripPolicy, normalizePolicy } from '@/utils/clientHelpers'
import { minDateString } from '@/utils/dateUtils'

export function mapApiTripItem(item: TripItem): TripItem {
  var policies = (Array.isArray(item.policies) ? item.policies : []).map((policy) => normalizePolicy(policy))
  var nonMultiTripPolicies = policies.filter((policy) => !isMultiTripPolicy(policy))
  var sourcePolicies = nonMultiTripPolicies.length ? nonMultiTripPolicies : policies
  var mainPolicy = sourcePolicies[0] ?? policies[0]
  return {
    ...item,
    policies,
    destination: mainPolicy?.destination ?? item.destination ?? 'Unknown',
    departureDate: minDateString(sourcePolicies.map((policy) => policy.departureDate)) ?? item.departureDate,
    returnDate: minDateString(sourcePolicies.map((policy) => policy.returnDate)) ?? item.expirationDate,
    mainPolicyId: mainPolicy?.id,
  }
}

export function mapApiTripItems(items: TripItem[]) {
  return items.map(mapApiTripItem)
}
